module.exports = __webpack_public_path__ + "aetos-ai/static/img/question.3b73105.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question.svg
// module id = PfSF
// module chunks = 13